module.exports = __webpack_public_path__ + "static/fcc_responsive_web_design-8e94bf812bcfbf8101137a3c7f43a07e.pdf";